import { pluralize } from './pluralize';

export const getRelativeTime = (dateString: string): string => {
    const now = new Date();
    const date = new Date(dateString);
    const diffInMs = now.getTime() - date.getTime();

    const diffInYears = Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 365));
    const diffInMonths = Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 30));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

    if (diffInYears > 0) {
        return `${diffInYears} ${pluralize(diffInYears, 'год', 'года', 'лет')} назад`;
    } else if (diffInMonths > 0) {
        return `${diffInMonths} ${pluralize(diffInMonths, 'месяц', 'месяца', 'месяцев')} назад`;
    } else if (diffInDays > 0) {
        return `${diffInDays} ${pluralize(diffInDays, 'день', 'дня', 'дней')} назад`;
    } else if (diffInHours > 0) {
        return `${diffInHours} ${pluralize(diffInHours, 'час', 'часа', 'часов')} назад`;
    } else if (diffInMinutes > 0) {
        return `${diffInMinutes} ${pluralize(diffInMinutes, 'минуту', 'минуты', 'минут')} назад`;
    } else {
        return 'только что';
    }
};
